<template>
  <div class="w-full">
    <transfer-reviewer
      ref="transferReviewer"
      @reload="reload"
      @close="selected = ''"
    />
    <new-transfer ref="newTransfer" @reload="getList" />
    <vs-table
      id="branchStockTransfers"
      ref="table"
      :data="branchStockTransfers"
      :max-items="itemsPerPage"
      v-model="selected"
    >
      <div
        slot="header"
        class="w-full flex flex-wrap items-center flex-grow justify-between"
      >
        <vs-row vs-type="flex" vs-w="12" class="mb-2">
          <global-filter
            ref="filterer"
            :tableOptions="tableOptions"
            :filterOptions="filterOptions"
            :filterChips="filterChips"
            :filterOptionNames="filterOptionNames"
            :isActive="isFilterActive"
            @saveOptions="saveOptions"
            @close="isFilterActive = false"
          />
          <vs-row
            id="panelHeaderRow"
            v-show="!isFilterActive"
            vs-type="flex"
            vs-w="12"
            vs-justify="space-between"
          >
            <vs-col
              id="panel-actions"
              vs-type="flex"
              class="w-auto"
              vs-justify="center"
            >
              <vs-row vs-type="flex" vs-w="12">
                <vs-col v-if="!$isCenterBranch()" vs-type="flex" class="w-auto">
                  <vx-tooltip text="Yeni Stok Transfer" position="top">
                    <vs-button
                      @click="openNewTransfer"
                      class="panel-action text-success xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="feather"
                      icon="icon-plus"
                    />
                  </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Detaylı Filtereleme" position="top">
                    <vs-button
                      @click="isFilterActive = !isFilterActive"
                      class="panel-action text-warning xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="pickicon"
                      icon="icon-pick-filter"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Excel Export" position="top">
                    <vs-button
                      @click="getExcel"
                      class="panel-action text-warning xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="feather"
                      icon="icon-download"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col id="filter-chips" vs-type="flex">
              <vs-row
                vs-type="flex"
                vs-w="12"
                vs-justify="center"
                vs-align="center"
              >
                <vs-button
                  id="clearFilterButton"
                  v-if="filterChips.length > 0"
                  @click="clearFilter"
                  class="mr-2 bg-white text-danger panel-action-box-shadow"
                  icon-pack="feather"
                  icon="icon-slash"
                  radius
                  color="transparent"
                />
                <vs-col
                  vs-type="flex"
                  class="w-auto"
                  v-for="(chip, index) in filterChips"
                  :key="index"
                >
                  <vs-chip
                    color="white"
                    class="panel-action-box-shadow px-1"
                    @click="removeFilter(chip.col, index)"
                    v-show="chip.value != ''"
                    closable
                  >
                    <vs-row vs-tpye="flex" vs-w="12">
                      <vs-col vs-tpye="flex" class="w-auto" vs-align="center">
                        <span class="bold text-xsmaller text-dark">
                          {{ chip.name + " :" }}
                        </span>
                      </vs-col>
                      <vs-col
                        vs-type="flex"
                        class="w-auto ml-1"
                        vs-align="center"
                      >
                        <span
                          class="weight-600 italic text-xsmaller text-primary"
                        >
                          {{ chip.value }}
                        </span>
                      </vs-col>
                    </vs-row>
                  </vs-chip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col
              id="table-page-size"
              vs-type="flex"
              class="w-auto"
              vs-justify="flex-end"
            >
              <vs-dropdown
                vs-trigger-click
                class="bg-white cursor-pointer panel-action-box-shadow"
              >
                <div
                  class="px-4 d-theme-border-grey-light d-theme-dark-bg cursor-pointer flex items-center justify-between text-small"
                >
                  <span class="mr-2 page-size-dropdown-span"
                    >{{ (currentPage + 1) * itemsPerPage - (itemsPerPage - 1) }}
                    -
                    {{
                      totalDataRow - (currentPage + 1) * itemsPerPage > 0
                        ? (currentPage + 1) * itemsPerPage
                        : totalDataRow
                    }}
                    of
                    {{ totalDataRow }}</span
                  >
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="itemsPerPage = 10">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 15">
                    <span>15</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 20">
                    <span>20</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-col>
          </vs-row>
        </vs-row>
      </div>

      <template slot="thead">
        <vs-th class="w-4/12">
          <span> Tarih </span>
        </vs-th>
        <vs-th class="w-3/12">
          <span> Saat </span>
        </vs-th>
        <vs-th class="w-5/12">
          <span> Durum </span>
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody style="text-align: center">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="w-4/12">
              <p class="text-center text-dark weight-500">{{ tr.date }}</p>
            </vs-td>
            <vs-td class="w-3/12">
              <p class="text-center text-dark weight-500">{{ tr.time }}</p>
            </vs-td>

            <vs-td class="w-5/12">
              <span
                :class="{
                  'text-danger': tr.status === 1 || tr.status === 4,
                  'text-warning': tr.status === 2,
                  'text-success': tr.status === 0 || tr.status === 3,
                }"
                class="text-success weight-600 text-smaller"
              >
                {{ stockTransferStatuses.find((x) => x.id === tr.status).name }}
              </span>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <pagination-default
      :setCurrentPage="tableOptions.pageIndex"
      :totalLenght="calculatePageLength"
      @currentPage="getCurrentPage"
    ></pagination-default>
  </div>
</template>

<script>
import TransferReviewer from "./TransferReviewer";
import NewTransfer from "./NewTransfer";
import PaginationDefault from "../PaginationDefault";
import GlobalFilter from "../GlobalFilter";
import {
  getBranchTransfers,
  getBranchTransfersForDealer,
  getBranchTransfersExcel,
  getBranchTransfersExcelForDealer
} from "@/api/MonthlyStockTransfer";
import { getStockTransferStatuses } from "@/model/constants/stockTransferStatuses";
export default {
  name: "BranchTransfers",
  data() {
    return {
      stockTransferStatuses: getStockTransferStatuses(),
      branchStockTransfers: [],
      totalDataRow: 0,
      tableOptions: {},
      currentPage: 0,
      itemsPerPage: 10,
      selected: {},

      isFilterActive: false,
      filterOptions: ["dateRange", "timeRange"],
      filterOptionNames: ["Tarih", "Saat"],
      filterChips: [],
    };
  },
  components: {
    PaginationDefault,
    GlobalFilter,
    NewTransfer,
    TransferReviewer,
  },
  computed: {
    calculatePageLength() {
      let mod = this.totalDataRow % this.itemsPerPage;
      return mod > 0
        ? (this.totalDataRow - mod) / this.itemsPerPage + 1
        : this.totalDataRow / this.itemsPerPage;
    },
  },
  methods: {
    reload() {
      this.getList();
      this.$emit("reload");
    },
    openNewTransfer() {
      this.$refs.newTransfer.isActive = true;
    },
    getExcel() {
      if (this.$isRegionalCenterBranch()) {
        getBranchTransfersExcelForDealer(this.tableOptions)
        .then((res) => {
          if (res && res.status === 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Şube Stok Transferleri.xlsx");
            document.body.appendChild(link);
            link.click();

            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Excel Export Başarılı !",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Excel Export İşlemi Başarısız !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
      } else {
        getBranchTransfersExcel(this.tableOptions)
        .then((res) => {
          if (res && res.status === 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Şube Stok Transferleri.xlsx");
            document.body.appendChild(link);
            link.click();

            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Excel Export Başarılı !",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Excel Export İşlemi Başarısız !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
      }
      
    },
    saveOptions(filterOptions, filterChips) {
      this.isFilterActive = false;
      if (_.isEqual(this.tableOptions, filterOptions)) return;
      this.tableOptions = _.cloneDeep(filterOptions);
      this.filterChips = _.cloneDeep(filterChips);
    },
    clearFilter() {
      this.tableOptions = {
        sortBy: "Created",
        sortDirection: "desc",
        pageIndex: 0,
        pageSize: this.itemsPerPage,
        branch: this.$isCenterBranch() ? null : this.$currentUser.branch,
        dateRange: {
          startDate: null, 
          endDate: null, 
        },
        timeRange: {
          startTime: null,
          endTime: null,
        },
      };
      this.filterChips.length = 0;
    },
    removeFilter(col, index) {
      this.tableOptions[col] = null;
      this.filterChips.splice(index, 1);
    },
    getCurrentPage(currentx) {
      this.currentPage = currentx - 1;
    },
    getList() {
      if (!this.tableOptions.branch) return;
      if (this.$isRegionalCenterBranch()) {
        getBranchTransfersForDealer(this.tableOptions).then((res) => {
        if (res && res.status == 200) {
          this.branchStockTransfers = res.data.items;
          this.totalDataRow = res.data.totalCount;
        }
      });
      }else{
        getBranchTransfers(this.tableOptions).then((res) => {
        if (res && res.status == 200) {
          this.branchStockTransfers = res.data.items;
          this.totalDataRow = res.data.totalCount;
        }
      });
      }
     
    },
    openTransferReviewer() {
      this.$refs.transferReviewer.isActive = true;
      this.$refs.transferReviewer.transferId = this.selected.id;
    },
  },
  watch: {
    tableOptions: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.getList();
        });
      },
    },
    selected(val) {
      if (val) {
        this.openTransferReviewer();
        this.selected = "";
      }
    },
    currentPage: function (val) {
      this.tableOptions.pageIndex = val;
    },
    itemsPerPage: function (val) {
      this.currentPage = 0;
      this.tableOptions.pageSize = val;
      this.tableOptions.pageIndex = this.currentPage;
    },
  },
  created() {
    this.clearFilter();
  },
};
</script>

<style scoped></style>
